import { useCallback } from 'react';

import type { PermissionType } from '../types/apiTypes';
import useEnsisQuery from './useEnsisQuery';

const useUserInfo = () => {
  const queryReturnData = useEnsisQuery('/app/users/me');
  const userHasGlobalPermission = useCallback((permission: PermissionType) => (
    queryReturnData.data?.global_permissions.includes(permission) ?? false
  ), [queryReturnData.data?.global_permissions]);

  return { userHasGlobalPermission, ...queryReturnData };
};

export default useUserInfo;
